import React from 'react';
import { ActionButtons } from '../ActionButtons';
import { AderenciaDePrecosHeader } from '../AderenciaDePrecosHeader';
import { LoadingSpinerArea } from '../../../../../../../components';
import { CadastroRangeDePrecos } from '../CadastroRangeDePrecos';
import { useSetupAderenciaDePrecosStore } from '../../SetupAderenciaDePrecos.store';
import { useSaveAderencia } from '../../hooks/useSaveAderencia';
import { filterPendingAderencia } from '../../utils';

export const ConfigFormSetupIsaAderenciaDePrecos = () => {
  const { aderenciaProductUploadResponse, aderenciaProdutoTableData, setToUploadInitialList } = useSetupAderenciaDePrecosStore();
  const pendingItems = filterPendingAderencia(aderenciaProdutoTableData);

  const { handleSaveAderenciaMutation } = useSaveAderencia();

  return (
    <div>
      <LoadingSpinerArea area="setup-aderencia" />

      <AderenciaDePrecosHeader />
      <CadastroRangeDePrecos />
      <ActionButtons
        pendingItems={pendingItems.length}
        onSave={() => handleSaveAderenciaMutation(aderenciaProductUploadResponse?.uploadId)}
        onCancel={() => setToUploadInitialList()}
      />
    </div>
  );
};
